import qs from 'qs';
import { useShoppingCartApi } from "@/layers/checkout/composables/useShoppingCartApi";
const EXCLUDED_FILTER_KEYS = ["q", "page_nr", "page_size", "sort", "direction", "order"];
export default defineNuxtPlugin(nuxtApp => {
    const runtimeConfig = useRuntimeConfig();
    const { vueApp } = useNuxtApp();
    const dataAll = useDataAll();
    const DEFAULT_ITEMS_PER_PAGE = 24;
    const itemPerPageOptions = [12,24,48,96];
    const { $apiMethods, $helpers } = useNuxtApp()
    const { updateCart } = useShoppingCartApi();
    const PAG = {
        itemPerPageOptions(){
          return itemPerPageOptions;
        },
        defaultItemsPerPage(){
          return DEFAULT_ITEMS_PER_PAGE
        },
        selectFilterValueByUrlOnlyFilter() {
            return Object.fromEntries(
                Object.entries(PAG.selectFilterValueByUrl()).filter(([key]) => !EXCLUDED_FILTER_KEYS.includes(key))
            );
        },

        // Extract parameters out of the url
        selectFilterValueByUrl() {
            let selectedParams = {}
            const route = useRoute();
            const url = route.fullPath;
            const filterIndex = url.indexOf('/filter/');

            if (filterIndex !== -1) {
                const filterPart = url.substring(filterIndex + 8); //the part after filter
                const filterSegments = filterPart.split('/');//array of url parameters

                filterSegments.forEach(segment => {
                    const [sequence, value] = segment.split('=');
                    if (sequence && value) {
                        const decodedValue = decodeURIComponent(value);
                        selectedParams[sequence] = decodedValue.includes(',') ? decodedValue.split(',') : decodedValue;
                    }
                });
            }
            return selectedParams
        },
        // navigate to filter page
        async updateFilter(selectedFiltersInput, changeParams) {
            const scrollPosition = window?window.scrollY:null;
            // Get the current route and router
            const route = useRoute();
            const router = useRouter();
            let newRoute = ''
            // add additonal params to router (paginating offset)
            if (typeof changeParams === 'object' && changeParams !== null) {
                // Iterated through tje key-value pairs of the  object
                Object.entries(changeParams).forEach(([key, value]) => {
                    if (value){
                        selectedFiltersInput[key] = value
                    } else {
                        delete selectedFiltersInput[key]

                    }
                });
            }

            // Construct the filter part of the URL
            let filterParams = Object.keys(selectedFiltersInput)
              .filter(sequence => selectedFiltersInput[sequence] !== '-' && selectedFiltersInput[sequence] !== '')
              .map(sequence => `${sequence}=${encodeURIComponent(selectedFiltersInput[sequence])}`)
              .join('/');

            if (filterParams.length > 0) {
              // Generate the new URL, ensuring only one occurrence of "filter" if there are filterParams and navigate
              newRoute = `${route.path.replace(/\/filter\/.*$/, '')}/filter/${filterParams}`;

            } else {
                // no filterparams, normal url
              if (`${route.path.replace(/\/filter\/.*$/, '')}` != route.path){
                newRoute = `${route.path.replace(/\/filter\/.*$/, '')}`
              }

            }
            await router.push(newRoute)
              if (scrollPosition) {
                 await nextTick();
                 setTimeout(() => {
                  window.scrollTo(0, scrollPosition);
                 }, 50);
              }

          },
          // make PAG api call
          async pagApiCall(pageItem){
              try{
                const { $apiMethods, $helpers } = useNuxtApp()
                // get query string
                const queryString = PAG.generatePagQueryString();

                // format API url
                const apiUrl =
                    $apiMethods.getApiHostUrl() +
                    "/api/" +
                    $helpers.getLabelId() +
                    "/pag/" +
                    dataAll.getLanguage() +
                    "/" +
                    pageItem.Code +
                    queryString

                // return api results.
                return $apiMethods.loadJSONApi(apiUrl)
             } catch (err) {
              return false
             }
          },
          async getArticleData(articleId){
            const { $apiMethods, $helpers } = useNuxtApp()
            const apiUrl = $apiMethods.getApiHostUrl() +
              "/api/" +
              $helpers.getLabelId() +
              "/article/" +
              dataAll.getLanguage() + "/" +
              articleId;
              return $apiMethods.loadJSONApi(apiUrl)

          },
          formatArticleUrl( article) {
            const lang = dataAll.getLanguage()
            const prefix = lang === dataAll.getDefaultLanguage() ? '' : `/${lang}`
            const base = `${prefix}/${ARTICLE_PATH}`

            const number = String(article?.Head?.ArticleNumber ?? '').trim()
            if (!number) return `${base}/`

            const slug = PAG.makeSlug(article?.Head?.ArticleName ?? '')
            return `${base}/${encodeURIComponent(number)}${slug ? `-${slug}` : ''}`
          },
          makeSlug(str) {
            return String(str ?? '')            // Guard against null, numbers and objects
                .normalize('NFD')                 // Split accented characters into base + diacritic
                .replace(/[\u0300-\u036f]/g, '')  // Strip the diacritic marks, keeping the base letter
                .toLowerCase()                    // Convert the string to lowercase
                .trim()                           // Remove extra spaces from the beginning and end
                .replace(/[\s_]+/g, '-')          // Replace spaces and underscores with hyphens
                .replace(/[^a-z0-9-]+/g, '')      // Remove all non-alphanumeric characters except hyphens
                .replace(/-{2,}/g, '-')           // Replace two or more consecutive hyphens with a single hyphen
                .slice(0, 100)                    // Limit the string to a maximum length of 100 characters
                .replace(/^-|-$/g, '')            // Remove hyphens from the start or end, after truncating
          },
          // generate query string
          generatePagQueryString(){
            const selectedFilters =PAG.selectFilterValueByUrl();

            let queryString = "";
            if (Object.entries(selectedFilters).length > 0){
                let selectedFiltersRes = {filters:{}}
                Object.entries(selectedFilters).forEach(([key, value]) => {
                  if (EXCLUDED_FILTER_KEYS.includes(key)) {
                    selectedFiltersRes[key] = value
                  } else if (typeof(value) =="string" ){
                    selectedFiltersRes.filters[key] =[value]
                  } else {
                    selectedFiltersRes.filters[key] =value
                  }

                })
                queryString = "?"+qs.stringify(selectedFiltersRes, { encode: false });
              }
              return queryString;
          },
        // add items to selector contorles
        addItems(sequence, pagData,selectorItem, addEmpty = true) {
            const checkLabel = (label) => {
                const str = String(label ?? '').trim();
                if (!/^\d+([.,]\d+)?$/.test(str)) onlyNumbers = false;
                if (!/^\d/.test(str)) allStartWithNumber = false;
            };
            const num = (s) => parseFloat(String(s).replace(',', '.'));
            const leadNum = (s) => {
                const m = String(s).match(/^\s*(\d+([.,]\d+)?)/);
                return m ? parseFloat(m[1].replace(',', '.')) : Number.POSITIVE_INFINITY;
            };

            // fill with default item
            let items = [];
            let onlyNumbers = true;
            let allStartWithNumber = true;

            if (addEmpty) {
              items = items.concat(
                            {
                                Value: '',
                                Title: `-`,
                            }
                        );
            }

            if (pagData?.facets) {
                pagData.facets.forEach(facet => {
                    if (facet?.config?.filterKey == selectorItem?.AttribuutSelectorName && selectorItem.SelectorType == "range") {
                        items = items.concat(
                            Object.entries(facet.options).map(([key, value]) => {
                                const label = PAG.translateRangeValue(value.label);
                                checkLabel(label);
                                return {
                                    Value: value.identifier,
                                    Title: `${value.label} (${value.count})`,
                                    Label: String(value.label ?? '').trim(),
                                    Count: value.count
                                };
                            })
                        );
                    } else if (facet.label == sequence) {
                        items = items.concat(
                            Object.entries(facet.options).map(([key, value]) => {
                            checkLabel(value.label);
                            return {
                                Value: value.identifier,
                                Title: `${value.label} (${value.count})`,
                                Label: String(value.label ?? '').trim(),
                                Count: value.count
                            };
                            })
                        );
                    }
                });
            }

            if (onlyNumbers) {
                // only numbers
                items.sort((a, b) => num(a.Label) - num(b.Label));
            } else if (allStartWithNumber) {
                // number prefix
                items.sort((a, b) => {
                    const d = leadNum(a.Label) - leadNum(b.Label);
                    // nl like sorting constant is oke for al languages right now, especialy sorting , floats
                    return d !== 0 ? d : a.Label.localeCompare(b.Label, 'nl', { sensitivity: 'base' });
                });
            } else {
                // sort on string
                // nl like sorting constant is oke for al languages right now, especialy sorting , floats
                items.sort((a, b) => {
                    if (!a.Label) return 1;
                    if (!b.Label) return -1;
                    return a.Label.localeCompare(b.Label, 'nl', { numeric: true, sensitivity: 'base' });
                });
            }

            return items;
        },
        translateRangeValue(stringIn){
          if (stringIn.includes("-*")){
            return dataAll.getStatic('pag_range_from','from')+" "+stringIn.replace("-*","");
          } else {
            return stringIn.replace("*-",dataAll.getStatic('pag_range_till','till')+" ");
          }
        },
        itemPropsDisabled(item) {
            return {
                title:    item.Title,
                value:    item.Value,
                disabled: item.Count == 0
            }
        },
        itemProps(item) {
            return {
                title:    item.Title,
                value:    item.Value,
            }
        },
        getFilterKey(label,pagData){
            let retValue= "TODO_notfound"
            if (pagData?.facets) {
                    pagData.facets.forEach(facet =>{
                      if (facet.label==label){
                        retValue =  facet.config.filterKey
                      }
                    })
                  }

            return retValue
        },

        addItemToCart(sku, name, amount){
          // todo can be moved to a beter place later
          updateCart(sku, name, amount)
        },
        isPAGPageType(pageType){
            const PAGPageTypes = ['PM', 'PS', 'ES'];
            return PAGPageTypes.includes(pageType);
        },
        isHistoryPagPage(history){
            const {  $methods } = useNuxtApp()
            if (!history.state?.back) {
                return false;
            }

            const backUrl = history.state.back;

            // Check for filter in URL (early exit)
            if (backUrl && backUrl.includes('/filter/')){
                return true;
            }

            const pageNames = dataAll.getKey('pageNames', []) 
            // check pageNames
            if (!pageNames || Object.keys(pageNames).length === 0) {
                return false;
            }

            // Search matching page code
            const matchingPageCode = Object.entries(pageNames).find(([key, value]) => 
                backUrl.includes(value)
            )?.[0];

            // no match, return false
            if (!matchingPageCode) {
                return false;
            }  

            const webPages = usePageOverviewStore().PageOverview;
            
            const pageContent = $methods.pageByCodeField(webPages, matchingPageCode, "Code");

            // Check if a page can be fount
            if (!pageContent) {
                return false;
            }


            return this.isPAGPageType(pageContent.PageType);
        }
    }
    nuxtApp.provide('PAG', PAG);
})